import {
  GETWithToken,
  POSTWithToken,
} from "./base-service";

const API_URL = "/api/notification/v1";
const NOTIFICATION_VIEWER_API_URL = "/api/notification/viewer/v1";
const NOTIFICATION_PAGE_SIZE = 10;

export const getNotificationUnreadCount = () => {
  const url = `${API_URL}/unread/count` ;
  return GETWithToken(url);
};

export const getNotification = () => {
  const url = `${API_URL}/list`;
  return GETWithToken(url, { limit: NOTIFICATION_PAGE_SIZE });
};

export const getNotificationList = ({ cursor, direction } = {}) => {
  const url = `${API_URL}/list`;
  const params = {};
  if (cursor) {
    params.cursor = cursor;
    params.direction = direction || "next";
  } else {
    params.limit = NOTIFICATION_PAGE_SIZE;
  }
  return GETWithToken(url, params);
};

export const markAllRead = () => {
  const url = `${NOTIFICATION_VIEWER_API_URL}/read/all`;
  return POSTWithToken(url);
};

export const notificationRead = (notificationIds) => {
  const data = { notificationIds };
  const url = `${NOTIFICATION_VIEWER_API_URL}/read`;
  return POSTWithToken(url, data);
};
